// eslint-disable-line jsx-a11y/no-static-element-interactions
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from 'react';
import useSWR from 'swr';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import {
  Modal,
  Snackbar,
  ConfirmationModal,
  ProjectorShimmer,
  ShareScreen,
} from 'Components';
import { AppContext } from 'Context';
import {
  Box,
  Typography,
  TextField,
  Button,
  Tab,
  Tabs,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  CircularProgress,
} from '@mui/material';
import ModalMaterial from '@mui/material/Modal';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Pathname } from 'Routes';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { ReactComponent as SaveButton } from 'Assets/saveButton.svg';
import Spinner from 'Components/Spinner';
import { ViewerPage } from '../components/page';
import GroupMemberList from './components/groupMembers';
import styles from './index.module.css';
import PendingInvites from './components/PendingInvites';

const DEFAULT_ALBUM_PLACEHOLDER = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgZmlsbD0iI2U4ZThlOCIvPgogIDx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkb21pbmFudC1iYXNlbGluZT0ibWlkZGxlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNWFhNWVmIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTZweCII+QWxidW08L3RleHQ+Cjwvc3ZnPg==';

const defaultSnackbar = {
  isVisible: false,
  type: undefined,
  message: undefined,
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '1200px',
  height: '85vh',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 3,
  overflow: 'hidden',
};

export const Groups = () => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const { userDetails, langText, setAppSnackbar } = useContext(AppContext);
  const [snackbar, setSnackbar] = useState(defaultSnackbar);
  const profileID = userDetails.myId;
  const [groups, setGroups] = useState(undefined);
  const [showMembers, setShowMember] = useState(null);
  const [groupMembers, setGroupMembers] = useState(undefined);
  const [pendingMembers, setpendingMembers] = useState(undefined);
  const [groupVideos, setGroupVideos] = useState(undefined);
  const [groupAlbums, setGroupAlbums] = useState(undefined);
  const [groupVideoData, setGroupVideoData] = useState(undefined);
  const [groupAlbumData, setGroupAlbumData] = useState(undefined);
  const [openConfirmationModal, setConfirmationModal] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [isDeleted, setDeleting] = useState(false);
  const [videos, setVideos] = useState(undefined);
  const [albums, setAlbums] = useState(undefined);
  const [saveButtonClass, setSaveButtonClass] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedVideos, setSelectedVideos] = useState(undefined);
  const [selectedAlbums, setSelectedAlbums] = useState(undefined);
  const [openGroupModal, setGroupModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [openSelectionModal, setOpenSelectionModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [editedGroupName, setEditedGroupName] = useState('');
  const [selectedOriginalName, setSelectedOriginalName] = useState('');
  const [editLoader, setEditLoader] = useState(false);
  const [allContent, setAllContent] = useState(undefined);
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [selectedOption, setSelectedOption] = useState(''); // State to hold the selected value
  // Modal content filtering states
  const [modalTabTitle, setModalTabTitle] = useState(0); // 0: Videos, 1: Albums
  const [modalContent, setModalContent] = useState([]);
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('created');
  const [order, setOrder] = useState('desc');
  const [albumFilterOptions, setAlbumFilterOptions] = useState([]);
  const groupsText = langText?.viewersSideBar?.groups;
  const commonText = langText?.common;
  const spinerSmall = 'spinex';
  const [categorySelected, setCategorySelected] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState(null);
  const scrollContainerRef = useRef(null);
  // Track current category/tab to prevent stale data issues
  const currentCategoryRef = useRef(null);
  // Skip refetch after outside-modal removal (local state is already correct)
  const skipRefetchRef = useRef(0);
  // Refs to track latest values for rapid clicks (avoids stale closure)
  const groupVideosRef = useRef(groupVideos);
  const groupAlbumsRef = useRef(groupAlbums);
  console.log('group members>>>', groupMembers);
  console.log('pending members>>>', pendingMembers);

  console.log('modelContent>>', modalContent);
  // console.log('categoryFilterOptions>>', categoryFilterOptions);
  // console.log('showmembers', showMembers);

  const { isValidating: fetchingCategoryFilter, mutate: fetchCategoryFilter } = useSWR([`${endpoints.getMyCategories}_filterA`], {
    fetcher: (url) => dataFetcher(endpoints.getMyCategories),
    onSuccess: ({ success, data }) => {
      // if (success) {
      //   setCategoryFilterOptions(
      //     data?.map(({ title: name, id: value }) => ({ name, value }))
      //   );
      // }
      if (success) {
        let categories = data?.map(({ title: name, id: value }) => ({ name, value })) || [];

        // Find "All Videos"
        const allVideosItem = categories.find(
          (item) => item.name?.toLowerCase() === 'all videos'
        );

        // Filter out "All Videos" from the rest
        const otherItems = categories.filter(
          (item) => item.name?.toLowerCase() !== 'all videos'
        );

        // Put "All Videos" first, then others
        if (allVideosItem) {
          categories = [allVideosItem, ...otherItems];
        }

        setCategoryFilterOptions(categories);
      }
    },
    onError: () => { },
  });
  const {
    isValidating: fetchingGetMyContent,
    mutate: fetchSelectionModalContent,
  } = useSWR(
    openSelectionModal ? [
      endpoints.getMyContentsBasedOnUploadDate,
      profileID,
      order,
      sortBy,
      currentPage,
      searchTerm,
      modalTabTitle === 0 ? (selectedCategoryFilter?.value || selectedOption?.value) : undefined, // Only send category for videos tab
      modalTabTitle, // Include tab in key to trigger refetch on tab change
    ] : null, // Don't fetch if modal is closed
    {
      fetcher: async (url, user_id, order_by, sort_by, page, search, category, tabType) => {
        const params = {
          user_id,
          order_by,
          sort_by,
          page,
          search,
        };
        console.log('sendingpage:', page);
        console.log('user_id:', user_id);
        // Only include category if we're on videos tab
        if (tabType === 0 && category) {
          params.category = category;
        }
        console.log('category:', category);
        const response = await dataFetcher(url, params);
        // Attach the requested page number to the response
        return { ...response, requestedPage: page };
      },
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 0, // Disable deduplication
      revalidateIfStale: true, // Always refetch if data is stale
      keepPreviousData: false, // Don't keep previous data when key changes
      onSuccess: ({ success, data, paginate, requestedPage }) => {
        console.log('📦 onSuccess - Requested Page:', requestedPage, '| Current State Page:', currentPage);
        console.log('onSuccess - data:', data);

        if (success) {
          // Verify this data is for the current category/tab - prevent stale data issues
          const expectedCategoryKey = `${modalTabTitle}-${selectedCategoryFilter?.value || 'all'}`;
          if (currentCategoryRef.current !== expectedCategoryKey) {
            console.log('⚠️ Ignoring stale data for old category:', currentCategoryRef.current, 'Expected:', expectedCategoryKey);
            return;
          }

          // Get the correct pagination info based on tab
          let paginationData;
          let newContent = [];

          if (modalTabTitle === 0) {
            paginationData = paginate?.video;
            newContent = data?.video || [];
          } else if (modalTabTitle === 1) {
            paginationData = paginate?.album;
            newContent = data?.album || [];
          } else if (modalTabTitle === 2) {
            paginationData = paginate?.draft;
            newContent = data?.videoDraftContents || [];
          }

          console.log('New content received:', newContent.length, 'items for page:', requestedPage);

          // Store pagination info
          setPaginationInfo(paginationData);
          // Check if current page is less than total number of pages
          const totalPages = parseInt(paginationData?.no_of_pages, 10) || 0;
          // Use requestedPage instead of currentPage state to determine if we have more pages
          const hasMore = requestedPage < totalPages;
          setHasMorePages(hasMore);

          // Always replace content when page is 1, append when page > 1
          // Use requestedPage from the actual request, not currentPage state
          if (requestedPage > 1) {
            console.log('➕ Appending to existing content (page', requestedPage, ')');
            setModalContent((prev) => {
              console.log('Previous:', prev.length, 'Adding:', newContent.length, 'Total will be:', prev.length + newContent.length);
              return [...prev, ...newContent];
            });
          } else {
            console.log('🔄 Replacing content with', newContent.length, 'items (page 1)');
            setModalContent(newContent);
          }

          setAllContent(data);
          setIsLoadingMore(false);
          setTimeout(() => {
            setIsContentLoaded(true);
          }, 1000);
        }
      },
      onError: () => {
        setIsLoadingMore(false);
      },
    }
  );

  // Monitor currentPage changes and trigger fetch
  useEffect(() => {
    if (currentPage > 1) {
      fetchSelectionModalContent();
    }
  }, [currentPage, fetchSelectionModalContent]);

  // Attach scroll listener to the container
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const onScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

      // Trigger when within 10px of bottom (only when user reaches the very end)
      if (distanceFromBottom < 10 && hasMorePages && !isLoadingMore && !fetchingGetMyContent) {
        setIsLoadingMore(true);
        setCurrentPage((prev) => prev + 1);
      }
    };

    container.addEventListener('scroll', onScroll);
    return () => container.removeEventListener('scroll', onScroll);
  }, [hasMorePages, isLoadingMore, fetchingGetMyContent]);

  // Reset pagination when filters change - split into two effects for proper timing
  useEffect(() => {
    if (openSelectionModal) {
      // Update the ref to track current category/tab combination
      const categoryKey = `${modalTabTitle}-${selectedCategoryFilter?.value || 'all'}`;
      currentCategoryRef.current = categoryKey;

      // Reset all state immediately
      setCurrentPage(1);
      setModalContent([]);
      setHasMorePages(true);
      setIsLoadingMore(false);
      setPaginationInfo(null);
      setIsContentLoaded(false);
    }
  }, [modalTabTitle, selectedCategoryFilter, sortBy, order, searchTerm, openSelectionModal]);

  // Separate effect to trigger refetch after state is updated
  useEffect(() => {
    if (openSelectionModal && currentPage === 1) {
      // Only trigger refetch when we're on page 1 (after reset)
      // This ensures SWR uses the correct page number
      fetchSelectionModalContent(undefined, { revalidate: true });
    }
  }, [modalTabTitle, selectedCategoryFilter, sortBy, order, searchTerm, openSelectionModal, currentPage, fetchSelectionModalContent]);

  // Fetch categories on component mount and when categories are updated anywhere in the app
  useEffect(() => {
    fetchSelectionModalContent();
    fetchCategoryFilter();
  }, []);

  // Update album filter options when album data changes
  useEffect(() => {
    if (modalTabTitle === 1 && allContent?.album) {
      // Transform album data to match category filter structure
      let transformedAlbums = allContent?.album?.map((album) => ({
        name: album.title || album.name || 'Untitled Album',
        value: album.id,
        title: album.title || album.name || 'Untitled Album',
        created: album.created,
      })) || [];

      // Sort the albums based on sortBy and order for LEFT SIDEBAR only
      transformedAlbums = transformedAlbums.sort((a, b) => {
        if (sortBy === 'title') {
          const comparison = a.title.localeCompare(b.title);
          return order === 'asc' ? comparison : -comparison;
        }
        if (sortBy === 'created') {
          const dateA = new Date(a.created || 0);
          const dateB = new Date(b.created || 0);
          return order === 'asc' ? dateA - dateB : dateB - dateA;
        }
        return 0;
      });

      setAlbumFilterOptions(transformedAlbums);
    }
  }, [modalTabTitle, allContent?.album, sortBy, order]);

  // console.log("fetchingCategoryFilter", categoryFilterOptions);
  // console.log("albumfilteroptions", albumFilterOptions);
  // console.log("fectchModaldata", modalContent);
  // console.log("videos", videos);
  // console.log("albums", albums);
  // console.log("groupVideos", groupVideos);
  // Existing SWR hooks (unchanged)
  const groupMembersKey = useMemo(
    () => (showMembers ? [endpoints.getMyGroupMembers, showMembers] : null),
    [showMembers]
  );

  const contentKey = useMemo(
    () => (profileID ? [endpoints.getVideosAndALbumsOfUser, profileID] : null),
    [profileID]
  );

  const groupContentKey = useMemo(() => (showMembers ? [endpoints.getVideosAndALbumsOfGroup, showMembers] : null),
    [showMembers]);

  const { isValidating: loadingGroups, mutate: fetchGroups } = useSWR(
    endpoints.getMyGroups,
    {
      onSuccess: ({ success, data }) => {
        if (success && data) {
          setGroups(data);
        } else {
          setGroups([]);
        }
      },
      onError: () => {
        setGroups([]);
      },
    }
  );

  const { isValidating: loadingGroupMembers, mutate: fetchGroupMembers } = useSWR(groupMembersKey, {
    fetcher: (url, id) => dataFetcher(url, { id }),
    onSuccess: ({ success, data, pending_members }) => {
      if (success && data) {
        setGroupMembers(data?.members);
        setpendingMembers(pending_members);
      } else {
        setGroupMembers(undefined);
      }
    },
    onError: () => {
      setGroupMembers(undefined);
    },
  });

  const { isValidating: fetchingContent, mutate: fetchContent } = useSWR(
    contentKey,
    {
      fetcher: (url, user_id) => dataFetcher(url, { user_id }),
      onSuccess: ({ success, album, video }) => {
        if (success) {
          setVideos(video);
          setAlbums(album);
        } else {
          setVideos(undefined);
          setAlbums(undefined);
        }
      },
      onError: () => {
        setVideos(undefined);
        setAlbums(undefined);
      },
    }
  );

  const { isValidating: fetchingGroupContent, mutate: fetchGroupContent } = useSWR(groupContentKey, {
    fetcher: (url, group_id) => dataFetcher(url, { group_id }),
    onSuccess: ({ success, album, video }) => {
      if (success) {
        setGroupVideos(video.map((item) => item.id));
        setGroupAlbums(album.map((item) => item.id));
        setGroupVideoData(video);
        setGroupAlbumData(album);
      } else {
        setGroupVideos(undefined);
        setGroupAlbums(undefined);
        setGroupVideoData(undefined);
        setGroupAlbumData(undefined);
      }
    },
    onError: () => {
      setGroupVideos(undefined);
      setGroupAlbums(undefined);
      setGroupVideoData(undefined);
      setGroupAlbumData(undefined);
    },
  });

  // Keep refs in sync with state (for when state is set by other sources like fetchGroupContent)
  useEffect(() => { groupVideosRef.current = groupVideos; }, [groupVideos]);
  useEffect(() => { groupAlbumsRef.current = groupAlbums; }, [groupAlbums]);

  const { isValidating: addingContentToGroup, mutate: addContentToGroup } = useSWR(
    showMembers && (selectedVideos || selectedAlbums)
      ? [
        endpoints.moveFilesToGroup,
        showMembers,
        selectedVideos,
        selectedAlbums,
      ]
      : null,
    {
      fetcher: (url, group_id, video_id, album_id) => dataFetcher(url, { group_id, video_id, album_id }),
      onSuccess: ({ success, album, video }) => {
        if (success) {
          if (skipRefetchRef.current > 0) {
            // Outside-modal removal: local state is already correct, skip refetch to avoid flicker
            skipRefetchRef.current -= 1;
          } else {
            // Modal save: refetch to get full data objects for newly added items
            fetchGroupContent();
          }
        }
      },
      onError: () => { },
    }
  );

  // Modal handlers
  const handleOpenSelectionModal = useCallback(() => {
    setOpenSelectionModal(true);
    // Initialize category ref
    const initialCategoryKey = `${modalTabTitle}-${categoryFilterOptions?.[0]?.value || 'all'}`;
    currentCategoryRef.current = initialCategoryKey;
    // Reset pagination
    setCurrentPage(1);
    setModalContent([]);
    setHasMorePages(true);
    setIsLoadingMore(false);
    setPaginationInfo(null);
    // No need to initialize temp arrays - we work directly with groupVideos/groupAlbums
    setSearchTerm('');
    // Select first category (All Videos) by default
    if (categoryFilterOptions && categoryFilterOptions.length > 0) {
      setSelectedCategoryFilter(categoryFilterOptions[0]);
    } else {
      setSelectedCategoryFilter(null);
    }
    // Fetch categories and content when modal opens
    fetchCategoryFilter();
    // Fetch content for the modal
    setTimeout(() => {
      fetchSelectionModalContent();
    }, 100);
  }, [categoryFilterOptions, fetchCategoryFilter, fetchSelectionModalContent]);

  const handleCloseSelectionModal = useCallback(() => {
    setOpenSelectionModal(false);
    setModalContent([]);
    // No need to reset temp arrays anymore
    setSearchTerm('');
    setSelectedCategoryFilter(null);
  }, []);

  // Filter handlers for modal
  const handleModalTabChange = useCallback((event, newValue) => {
    setModalTabTitle(newValue);
  }, []);

  const handleCategoryFilterSelect = useCallback((category) => {
    setSelectedCategoryFilter(category);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleSortChange = useCallback((event) => {
    setSortBy(event.target.value);
    // Trigger immediate API call when sort changes
    setTimeout(() => {
      fetchSelectionModalContent();
    }, 0);
  }, [fetchSelectionModalContent]);

  const handleOrderChange = useCallback((event) => {
    setOrder(event.target.value);
  }, []);

  const handlePageClick = useCallback(() => {
    // Pagination commented out - no action needed
  }, []);

  const addRemoveContent = useCallback((type, action, id) => {
    if (type === 'video') {
      if (action) {
        setGroupVideos((prev) => prev?.filter((video) => video !== id));
        setGroupVideoData((prev) => prev?.filter((video) => video.id !== id));
      } else {
        setGroupVideos((prev) => (prev ? [...prev, id] : [id]));
      }
    } else if (action) {
      setGroupAlbums((prev) => prev?.filter((album) => album !== id));
      setGroupAlbumData((prev) => prev?.filter((album) => album.id !== id));
    } else {
      setGroupAlbums((prev) => (prev ? [...prev, id] : [id]));
    }
  }, []);

  // Remove content from group and trigger API call (used outside modal)
  // Uses refs instead of closure values to handle rapid clicks correctly
  const removeContentFromGroup = useCallback((type, id) => {
    skipRefetchRef.current += 1;
    let newVideoIds;
    let newAlbumIds;

    if (type === 'video') {
      const updatedVideos = (groupVideosRef.current || []).filter((video) => video !== id);
      // Update ref synchronously so next rapid click reads the correct value
      groupVideosRef.current = updatedVideos;
      setGroupVideos(updatedVideos);
      setGroupVideoData((prev) => prev?.filter((video) => video.id !== id));
      newVideoIds = updatedVideos.length > 0 ? updatedVideos.toString() : undefined;
      newAlbumIds = groupAlbumsRef.current && groupAlbumsRef.current.length > 0 ? groupAlbumsRef.current.toString() : undefined;
    } else {
      const updatedAlbums = (groupAlbumsRef.current || []).filter((album) => album !== id);
      // Update ref synchronously so next rapid click reads the correct value
      groupAlbumsRef.current = updatedAlbums;
      setGroupAlbums(updatedAlbums);
      setGroupAlbumData((prev) => prev?.filter((album) => album.id !== id));
      newAlbumIds = updatedAlbums.length > 0 ? updatedAlbums.toString() : undefined;
      newVideoIds = groupVideosRef.current && groupVideosRef.current.length > 0 ? groupVideosRef.current.toString() : undefined;
    }

    setSelectedVideos(newVideoIds);
    setSelectedAlbums(newAlbumIds);
  }, []); // No dependencies - reads from refs

  // Content selection handlers - Use the same logic as outside modal
  const addRemoveModalContent = useCallback((type, isSelected, id) => {
    // Call the same function used outside modal
    // isSelected = true means item is already selected, so we remove it (action = true)
    // isSelected = false means item is not selected, so we add it (action = false)
    addRemoveContent(type, isSelected, id);
  }, []);

  // Save modal selections to actual group state and backend
  const handleSaveModalSelections = useCallback(() => {
    // Save to backend immediately using current groupVideos and groupAlbums
    const videoIds = (groupVideos || []).length > 0 ? (groupVideos || []).toString() : undefined;
    const albumIds = (groupAlbums || []).length > 0 ? (groupAlbums || []).toString() : undefined;

    setSelectedVideos(videoIds);
    setSelectedAlbums(albumIds);

    // Close modal
    handleCloseSelectionModal();
  }, [groupVideos, groupAlbums, handleCloseSelectionModal]);

  // handle select category
  const handleSidebarCategorySelect = (category) => {
    setSelectedCategoryFilter(category);
    setCategorySelected(false);
    // selectPage(1); // Reset to first page when changing filter

    // Trigger immediate API call when category changes
    setTimeout(() => {
      fetchSelectionModalContent();
    }, 0);
  };

  // Handle select album - Toggle album in/out of group
  const handleSidebarAlbumSelect = (album) => {
    const albumId = album.value;
    const isAlreadyInGroup = (groupAlbums || []).includes(albumId);

    // Toggle album in group (same as clicking on right side)
    if (isAlreadyInGroup) {
      // Remove from group
      setGroupAlbums((prev) => prev?.filter((id) => id !== albumId));
    } else {
      // Add to group
      setGroupAlbums((prev) => (prev ? [...prev, albumId] : [albumId]));
    }
  };

  // Existing callback functions (unchanged)
  const addNewMembers = useCallback(
    (id, title) => {
      navigate(Pathname.updatingGroup(id, title));
    },
    [navigate]
  );

  const showMemberDetails = useCallback((id) => {
    setShowMember(id);
  }, []);

  const addPhotoandVideoToGroup = useCallback(() => {
    setSelectedVideos(groupVideos ? groupVideos?.toString() : undefined);
    setSelectedAlbums(groupAlbums ? groupAlbums?.toString() : undefined);
  }, [groupVideos, groupAlbums]);

  const handleEditClick = useCallback((id, title) => {
    setSelectedOriginalName(title);
    setSelectedGroup(id);
    setEditedGroupName(title);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setSelectedGroup(null);
    setEditedGroupName('');
  }, []);

  const handleUpdate = useCallback(async () => {
    setEditLoader(true);
    try {
      const response = await axios.post(`${baseUrl}${endpoints.addNewGroup}`, {
        group_id: selectedGroup,
        title: editedGroupName,
      });
      // console.log('Updated Group:', response.data);
      fetchGroups();
      fetchContent();
      handleClose();
      setEditLoader(false);
      setAppSnackbar({
        isVisible: true,
        type: 'success',
        message: response.data.message,
      });
    } catch (error) {
      // console.error('Update failed:', error);
      setEditLoader(false);
    }
  }, [
    selectedGroup,
    editedGroupName,
    fetchGroups,
    fetchContent,
    handleClose,
    setAppSnackbar,
  ]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }, []);

  const prevGroupVideosLength = useRef();
  const prevGroupAlbumsLength = useRef();

  // Effects (unchanged)
  useEffect(() => {
    fetchGroups();
    fetchContent();
  }, [fetchGroups, fetchContent]);
  // useEffect(() => {
  //   fetchGroups();
  // }, [snackbar]);

  useEffect(() => {
    if (isDeleted) {
      const index = groups.findIndex((item) => item.id === showMembers);
      if (index !== -1) {
        groups.splice(index, 1);
      }
      setDeleting(false);
    }
  }, [isDeleted, groups, showMembers]);

  useEffect(() => {
    if (showMembers) {
      setGroupMembers(undefined);
      setpendingMembers(undefined);
      setGroupVideoData(undefined);
      setGroupAlbumData(undefined);
      const timer = setTimeout(() => {
        fetchGroupMembers();
        fetchGroupContent();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [showMembers, fetchGroupMembers, fetchGroupContent]);

  useEffect(() => {
    if (selectedVideos || selectedAlbums) {
      addContentToGroup();
    }
  }, [selectedVideos, selectedAlbums, addContentToGroup]);

  useEffect(() => {
    if (groupVideos && groupAlbums) {
      if (prevGroupVideosLength.current === undefined) {
        prevGroupVideosLength.current = groupVideos?.length;
      }
      if (prevGroupAlbumsLength.current === undefined) {
        prevGroupAlbumsLength.current = groupAlbums?.length;
      }

      const hasGroupVideosChanged = groupVideos?.length !== prevGroupVideosLength.current;
      const hasGroupAlbumsChanged = groupAlbums?.length !== prevGroupAlbumsLength.current;

      if (hasGroupVideosChanged || hasGroupAlbumsChanged) {
        setSaveButtonClass(true);
      } else {
        setSaveButtonClass(false);
      }

      prevGroupVideosLength.current = groupVideos?.length;
      prevGroupAlbumsLength.current = groupAlbums?.length;
    }
  }, [groupVideos, groupAlbums]);

  useEffect(() => {
    if ((openGroupModal && !location.search?.includes(Pathname.createGroup))
      || !location.search?.includes(Pathname.updateGroup)
    ) {
      fetchGroups();
      fetchContent();
      setShowMember(null);
    }
  }, [openGroupModal, location.search, fetchGroups, fetchContent]);

  useEffect(() => {
    if (location.search?.includes(Pathname.createGroup)) {
      setGroupModal(true);
    }
  }, [location.search]);

  // Trigger content fetch when modal filters change - UPDATED
  // useEffect(() => {
  //   if (
  //     openSelectionModal &&
  //     groupVideos !== undefined &&
  //     groupAlbums !== undefined
  //   ) {
  //     fetchModalContent();
  //   }
  // }, [

  //   // modalTabTitle,
  //   fetchModalContent,
  //   openSelectionModal,
  //   groupVideos,
  //   groupAlbums,
  // ]);

  // console.log("editLoader", editLoader);

  return (
    <>
      <ViewerPage
        title={groupsText?.title || 'Groups'}
        addActionName={groupsText?.newGroup || 'New Group'}
        link={Pathname.createGroup}
      >
        <div className={styles.allGroupContainer}>
          {loadingGroups ? (
            <ProjectorShimmer isLight />
          ) : (
            groups?.map(({ id, title, members }, idx) => (
              <div key={id} className={styles.groupContainer}>
                <div className={styles.groupHeader}>
                  <span className={styles.groupTitle}>{title}</span>
                  <div className={styles.groupHeaderActions}>
                    {showMembers === id ? (
                      <>
                        <EditIcon
                          className={styles.iconButton}
                          onClick={() => handleEditClick(id, title)}
                          sx={{ fontSize: 40 }}
                        />
                        <DeleteIcon
                          className={styles.iconButtonDelete}
                          onClick={() => {
                            setConfirmationModal(true);
                          }}
                          sx={{ fontSize: 40 }}
                        />
                        <KeyboardArrowDownIcon
                          className={styles.expandIcon}
                          onClick={() => {
                            setShowMember(null);
                          }}
                          sx={{
                            fontSize: 40,
                            transform: 'rotate(180deg)',
                            transition: 'all 0.2s ease',
                            color: '#6b7280',
                            backgroundColor: '#f3f4f6',
                            borderRadius: '50%',
                            padding: '0.5rem',
                            '&:hover': {
                              backgroundColor: '#e5e7eb'
                            }
                          }}
                        />
                      </>
                    ) : (
                      <KeyboardArrowDownIcon
                        className={styles.expandIcon}
                        onClick={() => {
                          showMemberDetails(id);
                          setGroupName(title);
                        }}
                        sx={{
                          fontSize: 40,
                          transition: 'all 0.2s ease',
                          color: '#6b7280',
                          backgroundColor: '#f3f4f6',
                          borderRadius: '50%',
                          padding: '0.5rem',
                          '&:hover': {
                            backgroundColor: '#e5e7eb'
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
                {showMembers === id ? (
                  <div className={styles.groupExpandedContainer}>
                    <div className={styles.topSectionsRow}>
                      {/* Left Section: Members Management */}
                      <div className={styles.membersSection}>
                        <div className={styles.sectionHeader}>
                          <div>
                            <h3 className={styles.sectionTitle}>Group Members</h3>
                            <span className={styles.sectionSubtitle}>
                              Manage who has access to this group
                            </span>
                          </div>
                          <span
                            onClick={() => {
                              addNewMembers(id, title);
                            }}
                            className={styles.addMember}
                            aria-hidden="true"
                          >
                            <span className={styles.addMemberText}>
                              Add Members
                            </span>
                          </span>
                        </div>

                        {loadingGroupMembers ? (
                          <div className={styles.loadingText}>
                            {`${commonText?.loading || 'Loading'}...`}
                          </div>
                        ) : (
                          <>
                            {(() => {
                              // Filter valid members
                              const validGroupMembers = (groupMembers || []).filter((member) => {
                                const hasName = member.firstname || member.lastname;
                                const hasEmail = member.email;
                                return hasName || hasEmail;
                              });
                              const validPendingMembers = (pendingMembers || []).filter((member) => {
                                const hasName = member.firstname || member.lastname;
                                const hasEmail = member.email;
                                return hasName || hasEmail;
                              });
                              const hasValidMembers = validGroupMembers.length > 0 || validPendingMembers.length > 0;

                              if (!hasValidMembers) {
                                return (
                                  <div className={styles.emptyMembersMessage}>
                                    No members in this group
                                  </div>
                                );
                              }

                              return (
                                <div className={styles.memberSubSection}>
                                  {/* Table Header Section */}
                                  <div className={styles.memberHeaderRow}>
                                    <span className={styles.memberHeaderName}>
                                      Name
                                    </span>
                                    <span className={styles.memberHeaderEmail}>
                                      Email
                                    </span>
                                    <span className={styles.memberHeaderActions}>
                                      Actions
                                    </span>
                                  </div>
                                  {/* Single continuous table body */}
                                  <div>
                                    {validGroupMembers.map(
                                      (
                                        { id, firstname, lastname, email, image },
                                        idx
                                      ) => (
                                        <GroupMemberList
                                          email={email}
                                          id={id}
                                          key={`member-${id}-${idx}`}
                                          firstname={firstname}
                                          lastname={lastname}
                                          setSnackbar={setSnackbar}
                                          group={showMembers}
                                          image={image}
                                        />
                                      )
                                    )}
                                    {validPendingMembers.map(
                                      (
                                        { id, firstname, lastname, email, image },
                                        idx
                                      ) => (
                                        <PendingInvites
                                          email={email}
                                          id={id}
                                          key={`pending-${email}-${idx}`}
                                          firstname={firstname}
                                          lastname={lastname}
                                          setSnackbar={setSnackbar}
                                          fetchGroupMembers={fetchGroupMembers}
                                          group={showMembers}
                                          image={image}
                                        />
                                      )
                                    )}
                                  </div>
                                </div>
                              );
                            })()}
                          </>
                        )}
                      </div>

                      {/* Content Display Sections */}
                      <div className={styles.contentDisplayWrapper}>
                        <div className={styles.contentDisplayHeader}>
                          <div>
                            <h3 className={styles.contentDisplayTitle}>Shared Content</h3>
                            <span className={styles.sectionSubtitle}>
                              Videos and albums shared with this group
                            </span>
                          </div>
                          <span
                            onClick={handleOpenSelectionModal}
                            className={styles.addMember}
                            aria-hidden="true"
                          >
                            <span className={styles.addMemberText}>
                              Add Video or Albums
                            </span>
                          </span>
                        </div>

                        {/* Videos and Albums Stacked Vertically */}
                        <div className={styles.videophotoparentcontainer}>
                          {/* Videos Section */}
                          <div className={styles.contentSection}>
                            <div className={styles.sectionHeader}>
                              <h3 className={styles.sectionTitle}>
                                Shared Videos (
                                {groupVideos?.length || 0}
                                )
                              </h3>
                            </div>
                            <div className={styles.itemList}>
                              {!groupVideoData || groupVideoData.length === 0 ? (
                                <div className={styles.emptyState}>
                                  <div className={styles.emptyStateIcon}>🎥</div>
                                  <p className={styles.emptyStateText}>No videos shared yet</p>
                                  <p className={styles.emptyStateSubtext}>Click &quot;Add Video or Albums&quot; to get started</p>
                                </div>
                              ) : (
                                groupVideoData
                                  .map(({
                                    id,
                                    title,
                                    thumbnails,
                                    video_duration,
                                    Category,
                                  },
                                    idx) => {
                                    // thumbnails from getVideosAndALbumsOfGroup is a direct CloudFront signed URL
                                    const thumbnail = typeof thumbnails === 'string'
                                      ? thumbnails.replace(/\\/g, '')
                                      : null;
                                    return (
                                      <div
                                        key={`video-${id}-${idx}`}
                                        className={styles.contentItem}
                                      >
                                        <div className={styles.contentItemInner}>
                                          {thumbnail && (
                                            <div
                                              className={
                                                styles.thumbnailContainer
                                              }
                                            >
                                              <img
                                                src={thumbnail}
                                                alt={title}
                                                className={styles.thumbnail}
                                                onError={(e) => {
                                                  e.target.style.display = 'none';
                                                }}
                                              />
                                              {video_duration && (
                                                <span className={styles.duration}>
                                                  {video_duration}
                                                  s
                                                </span>
                                              )}
                                            </div>
                                          )}
                                          <div className={styles.contentDetails}>
                                            <span
                                              className={
                                                styles.videoTitleEnhanced
                                              }
                                            >
                                              {title}
                                            </span>
                                            {Category && (
                                              <span
                                                className={styles.categoryLabel}
                                              >
                                                {Category}
                                              </span>
                                            )}
                                          </div>
                                          <div
                                            className={styles.selectIconContainer}
                                          >
                                            <CheckCircleIcon
                                              className={
                                                styles.selectIconEnhanced
                                              }
                                              onClick={() => {
                                                removeContentFromGroup(
                                                  'video',
                                                  id
                                                );
                                              }}
                                              sx={{
                                                color: '#5aa5ef',
                                                fontSize: 28,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                  color: '#4a95df',
                                                  transform: 'scale(1.15)',
                                                },
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }))}
                            </div>
                          </div>

                          {/* Albums Section - Now under Videos */}
                          <div className={styles.contentSection}>
                            <div className={styles.sectionHeader}>
                              <h3 className={styles.sectionTitle}>
                                Photo Albums (
                                {groupAlbums?.length || 0}
                                )
                              </h3>
                            </div>
                            <div className={styles.itemList}>
                              {!groupAlbumData || groupAlbumData.length === 0 ? (
                                <div className={styles.emptyState}>
                                  <div className={styles.emptyStateIcon}>📷</div>
                                  <p className={styles.emptyStateText}>No photo albums shared yet</p>
                                  <p className={styles.emptyStateSubtext}>Click &quot;Add Video or Albums&quot; to get started</p>
                                </div>
                              ) : (
                                groupAlbumData
                                  .map(({
                                    id,
                                    title,
                                    icon,
                                    photo_count,
                                    created,
                                    description,
                                  },
                                    idx) => {
                                    // icon from getVideosAndALbumsOfGroup is a direct CloudFront signed URL
                                    const thumbnail = typeof icon === 'string'
                                      ? icon.replace(/\\/g, '')
                                      : null;

                                    return (
                                      <div
                                        key={`album-${id}-${idx}`}
                                        className={styles.contentItem}
                                      >
                                        <div className={styles.contentItemInner}>
                                          <div
                                            className={styles.thumbnailContainer}
                                          >
                                            <img
                                              src={thumbnail
                                                || DEFAULT_ALBUM_PLACEHOLDER}
                                              alt={title}
                                              className={styles.thumbnail}
                                              onError={(e) => {
                                                if (e.target.src
                                                  !== DEFAULT_ALBUM_PLACEHOLDER
                                                ) {
                                                  e.target.src = DEFAULT_ALBUM_PLACEHOLDER;
                                                }
                                              }}
                                            />
                                            {photo_count && (
                                              <span className={styles.duration}>
                                                {photo_count}
                                                {' '}
                                                photos
                                              </span>
                                            )}
                                          </div>
                                          <div className={styles.contentDetails}>
                                            <span
                                              className={
                                                styles.videoTitleEnhanced
                                              }
                                            >
                                              {title}
                                            </span>
                                            {(created || description) && (
                                              <div
                                                className={styles.categoryLabel}
                                              >
                                                {created && (
                                                  <span>
                                                    {formatDate(created)}
                                                  </span>
                                                )}
                                                {description && (
                                                  <span>
                                                    {' '}
                                                    •
                                                    {' '}
                                                    {description}
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            className={styles.selectIconContainer}
                                          >
                                            <CheckCircleIcon
                                              className={
                                                styles.selectIconEnhanced
                                              }
                                              onClick={() => {
                                                removeContentFromGroup(
                                                  'album',
                                                  id
                                                );
                                              }}
                                              sx={{
                                                color: '#5aa5ef',
                                                fontSize: 28,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                  color: '#4a95df',
                                                  transform: 'scale(1.15)',
                                                },
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Action Area */}
                    {/*
                   <div className={styles.actionArea}>
                      <button
                        disabled={
                          !saveButtonClass ||
                          addingContentToGroup ||
                          fetchingGroupContent
                        }
                        className={styles.loaderButton}
                        onClick={addPhotoandVideoToGroup}
                      >
                        {!addingContentToGroup ? (
                          "Save Changes"
                        ) : (
                          <Spinner spinex={spinerSmall} />
                        )}
                      </button>
                      {saveButtonClass && (
                        <span className={styles.saveHint}>
                          You have unsaved changes
                        </span>
                      )}
                    </div>
                   */}
                  </div>
                ) : null}
              </div>
            ))
          )}
        </div>
      </ViewerPage>

      {/* Snackbar and Confirmation Modal (unchanged) */}
      <Snackbar
        isVisible={snackbar?.isVisible}
        message={snackbar?.message || '.....'}
        onClose={() => {
          setSnackbar(defaultSnackbar);
        }}
        type={snackbar?.type}
      />

      {openConfirmationModal ? (
        <ConfirmationModal
          isVisible={openConfirmationModal}
          title={`Are you sure you want to delete Group ${groupName}`}
          onHide={() => {
            setConfirmationModal(false);
          }}
          cancelButton={commonText?.goBack || 'Go Back'}
          continueButton={commonText?.remove || 'Remove'}
          id={showMembers}
          name={groupName}
          setSnackbar={setSnackbar}
          removeType="group"
          setDeleting={setDeleting}
        />
      ) : null}

      {/* Edit Group Modal (unchanged) */}
      <ModalMaterial open={open} onClose={handleClose}>
        <Box sx={{ ...style, width: 400, height: 'auto' }}>
          <Typography variant="h6" sx={{ fontFamily: 'Poppins, sans-serif' }}>
            Edit the Group Name
          </Typography>

          <TextField
            autoFocus
            variant="standard"
            fullWidth
            placeholder="Enter Group Name"
            value={editedGroupName}
            onChange={(e) => setEditedGroupName(e.target.value)}
            InputProps={{
              disableUnderline: false,
              sx: {
                fontFamily: 'Poppins, sans-serif',
                '&:after': { borderBottomColor: '#5aa5ef' },
              },
            }}
            sx={{ mt: 2, fontFamily: 'Poppins, sans-serif' }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              disabled={
                !editedGroupName.trim()
                || editedGroupName === selectedOriginalName
                || editLoader
              }
              sx={{
                bgcolor: '#5aa5ef',
                color: 'white',
                fontFamily: 'Poppins, sans-serif',
                textTransform: 'capitalize',
                fontWeight: 500,
                fontSize: '14px',
                boxShadow: 'none',
                opacity: 1,
                '&.Mui-disabled': {
                  fontWeight: 500,
                  fontSize: '14px',
                  opacity: 0.5,
                  cursor: 'not-allowed',
                  boxShadow: 'none',
                  bgcolor: '#5aa5ef',
                  color: 'white',
                  fontFamily: 'Poppins, sans-serif',
                  textTransform: 'capitalize',
                },
              }}
            >
              {editLoader ? (
                <span
                  style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                >
                  Updating
                  {' '}
                  <Spinner spinex={spinerSmall} />
                </span>
              ) : (
                'Update'
              )}
            </Button>
          </Box>
        </Box>
      </ModalMaterial>

      {/* Advanced Content Selection Modal - YourVideos Style */}
      <ModalMaterial
        open={openSelectionModal}
        onClose={handleCloseSelectionModal}
      >
        <Box
          sx={{
            ...style,
            fontFamily: 'Montserrat, sans-serif',
            height: '90vh',
            width: '95%',
            maxWidth: '1600px',
            background: '#ffffff',
            padding: 0,
            borderRadius: '1rem',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              padding: '1.5rem 2rem',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#f9fafb',
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: '700',
                fontSize: '1.5rem',
                color: '#111827',
                letterSpacing: '-0.02em',
              }}
            >
              Add Content to Group
            </Typography>
            <button
              onClick={handleCloseSelectionModal}
              style={{
                background: '#f3f4f6',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#6b7280',
                padding: '0.5rem',
                lineHeight: '1',
                borderRadius: '0.5rem',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#e5e7eb';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#f3f4f6';
              }}
            >
              ×
            </button>
          </Box>

          {/* Main Layout Container */}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              overflow: 'hidden',
            }}
          >
            {/* Left Sidebar - Categories/Albums */}
            <Box
              sx={{
                width: '260px',
                borderRight: '2px solid #e3e8ef',
                overflowY: 'auto',
                background: '#fafbfc',
                padding: '20px 16px',
              }}
            >
              {/* Sidebar Header with Sort Dropdown */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '16px',
                  paddingLeft: '8px',
                  paddingRight: '8px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: '700',
                    fontSize: '16px',
                    color: '#1a202c',
                  }}
                >
                  {modalTabTitle === 0 ? 'Categories' : 'Albums'}
                </Typography>

                {/* Sort Dropdown - Only visible for Albums tab */}
                {modalTabTitle === 1 && (
                  <FormControl
                    sx={{
                      minWidth: 130,
                    }}
                  >
                    <Select
                      value={`${sortBy}_${order}`}
                      onChange={(e) => {
                        const [newSortBy, newOrder] = e.target.value.split('_');
                        setSortBy(newSortBy);
                        setOrder(newOrder);
                        // No API call - sorting is done locally in useEffect
                        // Only left sidebar will be sorted, right content stays unsorted
                      }}
                      displayEmpty
                      sx={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '12px',
                        height: '32px',
                        borderRadius: '6px',
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e3e8ef',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#5aa5ef',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#5aa5ef',
                        },
                      }}
                    >
                      <MenuItem value="created_desc" sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                        Date (New)
                      </MenuItem>
                      <MenuItem value="created_asc" sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                        Date (Old)
                      </MenuItem>
                      <MenuItem value="title_asc" sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                        Name (A-Z)
                      </MenuItem>
                      <MenuItem value="title_desc" sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '12px' }}>
                        Name (Z-A)
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Box>
              {modalTabTitle === 0 && fetchingCategoryFilter ? (
                <Box sx={{ padding: '20px', textAlign: 'center' }}>
                  <CircularProgress size={24} />
                </Box>
              ) : (
                <Box
                  sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
                >
                  {/* Show categories for videos, albums for albums tab */}
                  {(modalTabTitle === 0
                    ? categoryFilterOptions
                    : albumFilterOptions // Always show all albums in left sidebar
                  )?.map((item) => {
                    // For videos: check filter selection, for albums: no background selection
                    const isFilterSelected = modalTabTitle === 0
                      ? selectedCategoryFilter?.value === item.value
                      : false; // Albums don't use background selection

                    // Check if this album is in the group (for checkmark display)
                    const isInGroup = modalTabTitle === 1 && (groupAlbums || []).includes(item.value);

                    return (
                      <Box
                        key={item.value}
                        onClick={() => {
                          if (modalTabTitle === 0) {
                            handleSidebarCategorySelect(item);
                          } else {
                            handleSidebarAlbumSelect(item);
                          }
                        }}
                        sx={{
                          padding: '12px 16px',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          background: isFilterSelected
                            ? '#5aa5ef'
                            : 'transparent',
                          color: isFilterSelected
                            ? 'white'
                            : '#4a5568',
                          fontFamily: 'Poppins, sans-serif',
                          fontSize: '14px',
                          fontWeight: isFilterSelected
                            ? '600'
                            : '500',
                          transition: 'all 0.2s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          '&:hover': {
                            background: isFilterSelected
                              ? '#4a95df'
                              : '#e3e8ef',
                          },
                        }}
                      >
                        <span>{item.name}</span>
                        {isInGroup && (
                          <CheckCircleIcon
                            sx={{
                              color: '#5aa5ef',
                              fontSize: 18,
                              marginLeft: '8px',
                            }}
                          />
                        )}
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>

            {/* Right Content Area */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              {/* Tabs */}
              <Tabs
                value={modalTabTitle}
                onChange={handleModalTabChange}
                TabIndicatorProps={{
                  style: { background: '#5aa5ef', height: '3px' },
                }}
                sx={{
                  borderBottom: '2px solid #e3e8ef',
                  paddingLeft: '24px',
                  minHeight: '56px',
                }}
              >
                <Tab
                  label="Videos"
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '18px',
                    fontWeight: '600',
                    textTransform: 'none',
                    color: modalTabTitle === 0 ? '#1a202c' : '#718096',
                    '&.Mui-selected': {
                      color: '#1a202c',
                    },
                  }}
                />
                <Tab
                  label="Albums"
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '18px',
                    fontWeight: '600',
                    textTransform: 'none',
                    color: modalTabTitle === 1 ? '#1a202c' : '#718096',
                    '&.Mui-selected': {
                      color: '#1a202c',
                    },
                  }}
                />
              </Tabs>

              {/* Search and Filters Bar */}
              {/* <Box
                sx={{
                  padding: '16px 24px',
                  borderBottom: '1px solid #e3e8ef',
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center',
                }}
              > */}
              {/* Search Input */}
              {/* <input
                  type="text"
                  placeholder={`Search ${modalTabTitle === 0 ? 'videos' : 'albums'
                    }...`}
                  value={searchTerm}
                  onChange={handleSearchChange}
                  style={{
                    width: '400px',
                    padding: '10px 16px',
                    border: '1px solid #e3e8ef',
                    borderRadius: '8px',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'all 0.2s ease',
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#5aa5ef';
                    e.target.style.boxShadow = '0 0 0 3px rgba(90, 165, 239, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e3e8ef';
                    e.target.style.boxShadow = 'none';
                  }}
                /> */}

              {/* Sort Dropdown */}
              {/* <select
                  value={sortBy}
                  onChange={handleSortChange}
                  style={{
                    padding: "10px 16px",
                    border: "1px solid #e3e8ef",
                    borderRadius: "8px",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "14px",
                    cursor: "pointer",
                    outline: "none",
                    minWidth: "180px",
                  }}
                >
                  <option value="created">Sort by Date</option>
                  <option value="title">Sort by Name</option>
                </select> */}

              {/* Order Toggle */}
              {/* <button
                  onClick={() => setOrder(order === "asc" ? "desc" : "asc")}
                  style={{
                    padding: "10px",
                    border: "1px solid #e3e8ef",
                    borderRadius: "8px",
                    background: "#fff",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.borderColor = "#5aa5ef";
                    e.target.style.background = "#f7faff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.borderColor = "#e3e8ef";
                    e.target.style.background = "#fff";
                  }}
                  title={order === "asc" ? "Ascending" : "Descending"}
                >
                  {order === "asc" ? "↑" : "↓"}
                </button> */}
              {/* </Box> */}

              {/* Grid Content Area */}
              <Box
                ref={scrollContainerRef}
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '24px',
                  background: '#fafbfc',
                }}
              >
                {fetchingGetMyContent && currentPage === 1 ? (
                  <Box sx={{ textAlign: 'center', padding: '60px 20px' }}>
                    <CircularProgress size={40} />
                    <Typography
                      sx={{
                        marginTop: '16px',
                        fontFamily: 'Poppins, sans-serif',
                        color: '#718096',
                      }}
                    >
                      Loading content...
                    </Typography>
                  </Box>
                ) : (
                  (() => {
                    // Always use modalContent which now contains paginated data
                    const filteredContent = modalContent || [];

                    return filteredContent?.length > 0 ? (
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns:
                            'repeat(auto-fill, minmax(260px, 1fr))',
                          gap: '16px',
                        }}
                      >
                        {filteredContent?.map((item) => {
                          // console.log('item', item);

                          const isVideo = modalTabTitle === 0;
                          // When category is selected, modalContent uses content_id, otherwise use id
                          const itemId = item?.content_id || item?.id;
                          // Check if item is in the group to show as selected
                          const isSelected = isVideo
                            ? (groupVideos || []).includes(itemId)
                            : (groupAlbums || []).includes(itemId);

                          // Thumbnail logic matching YourVideos implementation
                          const rawThumbnail = item?.thumbnail || item?.thumbnails;
                          const thumbnail = Array.isArray(rawThumbnail)
                            ? rawThumbnail[0] || DEFAULT_ALBUM_PLACEHOLDER
                            : rawThumbnail || DEFAULT_ALBUM_PLACEHOLDER;

                          return (
                            <div
                              key={`modal-content-${modalTabTitle}-${itemId}`}
                              role="button"
                              tabIndex={0}
                              onClick={(e) => {
                                // Only trigger if clicking the card itself, not the checkbox
                                if (e.target === e.currentTarget || e.target.tagName === 'IMG' || e.target.tagName === 'H4' || e.target.tagName === 'P' || e.target.tagName === 'SPAN') {
                                  addRemoveModalContent(
                                    isVideo ? 'video' : 'album',
                                    isSelected,
                                    itemId
                                  );
                                }
                              }}
                              onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  e.preventDefault();
                                  addRemoveModalContent(
                                    isVideo ? 'video' : 'album',
                                    isSelected,
                                    itemId
                                  );
                                }
                              }}
                              style={{
                                border: `2px solid ${isSelected ? '#5aa5ef' : '#e3e8ef'
                                  }`,
                                borderRadius: '12px',
                                padding: '12px',
                                backgroundColor: isSelected
                                  ? '#f0f8ff'
                                  : '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.25s ease',
                                boxShadow: isSelected
                                  ? '0 4px 12px rgba(90, 165, 239, 0.2)'
                                  : '0 1px 3px rgba(0, 0, 0, 0.06)',
                              }}
                              onMouseEnter={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.borderColor = '#cbd5e0';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.borderColor = '#e3e8ef';
                                  e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.06)';
                                  e.currentTarget.style.transform = 'translateY(0)';
                                }
                              }}
                            >
                              {/* Image Box */}
                              <div
                                style={{
                                  position: 'relative',
                                  marginBottom: '10px',
                                  width: '100%',
                                  height: '120px',
                                  overflow: 'hidden',
                                  borderRadius: '6px',
                                  background: '#f7f7f7',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <img
                                  src={thumbnail}
                                  alt={item.title || 'thumbnail'}
                                  loading="lazy"
                                  onError={(e) => {
                                    if (
                                      e.target.src !== DEFAULT_ALBUM_PLACEHOLDER
                                    ) {
                                      e.target.src = DEFAULT_ALBUM_PLACEHOLDER;
                                    }
                                  }}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '6px',
                                    transition: 'opacity 0.3s ease',
                                  }}
                                />
                                {/* Selection Icon - Same as outside modal */}
                                {isSelected ? (
                                  <CheckCircleIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addRemoveModalContent(
                                        isVideo ? 'video' : 'album',
                                        isSelected,
                                        itemId
                                      );
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: '8px',
                                      right: '8px',
                                      color: '#5aa5ef',
                                      fontSize: 28,
                                      cursor: 'pointer',
                                      transition: 'all 0.2s ease',
                                      '&:hover': {
                                        color: '#4a95df',
                                        transform: 'scale(1.15)',
                                      },
                                    }}
                                  />
                                ) : (
                                  <RadioButtonUncheckedIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      addRemoveModalContent(
                                        isVideo ? 'video' : 'album',
                                        isSelected,
                                        itemId
                                      );
                                    }}
                                    sx={{
                                      position: 'absolute',
                                      top: '8px',
                                      right: '8px',
                                      color: '#cbd5e0',
                                      fontSize: 28,
                                      cursor: 'pointer',
                                      transition: 'all 0.2s ease',
                                      '&:hover': {
                                        color: '#5aa5ef',
                                      },
                                    }}
                                  />
                                )}
                                {/* <span
                                  style={{
                                    position: 'absolute',
                                    bottom: '6px',
                                    right: '6px',
                                    background: 'rgba(0,0,0,0.6)',
                                    color: '#fff',
                                    fontSize: '12px',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                  }}
                                >
                                  {isVideo
                                    ? `${item.video_duration || 0}s`
                                    : `${item.photo_count || 0} photos`}
                                </span> */}
                              </div>

                              {/* Text Info */}
                              <h4
                                style={{
                                  fontSize: '14px',
                                  fontWeight: '600',
                                  margin: '0 0 4px 0',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {item.title}
                              </h4>

                              <p
                                style={{
                                  fontSize: '12px',
                                  color: '#666',
                                  margin: '0',
                                }}
                              >
                                {isVideo
                                  ? item.Category
                                  && `Category: ${item.Category}`
                                  : item.created && formatDate(item.created)}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <Box sx={{ textAlign: 'center', padding: '60px 20px' }}>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins, sans-serif',
                            color: '#718096',
                            fontSize: '15px',
                          }}
                        >
                          No
                          {' '}
                          {modalTabTitle === 0 ? 'videos' : 'albums'}
                          {' '}
                          available
                        </Typography>
                      </Box>
                    );
                  })()
                )}

                {/* Loading indicator for pagination - only show when we have content and loading more */}
                {isLoadingMore && modalContent.length > 0 && (
                  <Box sx={{ textAlign: 'center', padding: '20px' }}>
                    <CircularProgress size={30} />
                    <Typography
                      sx={{
                        marginTop: '12px',
                        fontFamily: 'Poppins, sans-serif',
                        color: '#718096',
                        fontSize: '14px',
                      }}
                    >
                      Loading more...
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Pagination - Commented out */}
              {/* <Box
                sx={{
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "center",
                  background: "#fff",
                }}
              >
                <ReactPaginate
                  nextLabel={`${window.screen.width > 900 ? 'next >' : '>'}`}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={1}
                  marginPagesDisplayed={1}
                  pageCount={1}
                  previousLabel={`${window.screen.width > 900 ? '< previous' : '<'}`}
                  pageClassName={styles.pageItem}
                  pageLinkClassName={styles.pageLink}
                  previousClassName={styles.pageItem}
                  previousLinkClassName={styles.pageLink}
                  nextClassName={styles.pageItem}
                  nextLinkClassName={styles.pageLink}
                  breakLabel="..."
                  breakClassName={styles.pageItem}
                  breakLinkClassName={styles.pageLink}
                  containerClassName={styles.pagination}
                  activeClassName={styles.active}
                  renderOnZeroPageCount={null}
                />
              </Box> */}

              {/* Footer Actions */}
              <Box
                sx={{
                  padding: '20px 28px',
                  borderTop: '2px solid #e3e8ef',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  background: '#fff',
                }}
              >
                {/* Action buttons */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center', // ✅ vertically centers both buttons
                    justifyContent: 'flex-end', // ✅ pushes them to the right (optional)
                    gap: '12px', // ✅ consistent spacing between buttons
                  }}
                >
                  <button
                    onClick={handleCloseSelectionModal}
                    style={{
                      padding: '11px 24px',
                      border: '2px solid #e3e8ef',
                      borderRadius: '10px',
                      background: '#fff',
                      cursor: 'pointer',
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#4a5568',
                      transition: 'all 0.2s ease',
                      height: '42px', // ✅ ensures both buttons have same height
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#f7fafc';
                      e.target.style.borderColor = '#cbd5e0';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '#fff';
                      e.target.style.borderColor = '#e3e8ef';
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleSaveModalSelections}
                    disabled={addingContentToGroup}
                    style={{
                      padding: '11px 24px',
                      border: 'none',
                      borderRadius: '10px',
                      background: addingContentToGroup ? '#93c5fd' : '#3b82f6',
                      cursor: addingContentToGroup ? 'not-allowed' : 'pointer',
                      fontFamily: 'Montserrat, sans-serif',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'white',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
                      opacity: addingContentToGroup ? 0.7 : 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      height: '42px', // ✅ same height as Cancel button
                    }}
                    onMouseEnter={(e) => {
                      if (!addingContentToGroup) {
                        e.target.style.background = '#2563eb';
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.4)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!addingContentToGroup) {
                        e.target.style.background = '#3b82f6';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 8px rgba(59, 130, 246, 0.3)';
                      }
                    }}
                  >
                    {addingContentToGroup ? (
                      <>
                        Saving...
                        <CircularProgress size={16} sx={{ color: 'white' }} />
                      </>
                    ) : (
                      'Save Changes'
                    )}
                  </button>
                </Box>

              </Box>
            </Box>
          </Box>
        </Box>
      </ModalMaterial>
    </>
  );
};
